var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalesReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 11C3.14924 11 3 10.8508 3 10.6667V10.2936C3 10.2052 3.03512 10.1204 3.09763 10.0579V10.0579C3.30762 9.84794 3.66667 9.99666 3.66667 10.2936V10.6667C3.66667 10.8508 3.51743 11 3.33333 11V11ZM5.16667 11C4.98257 11 4.83333 10.8508 4.83333 10.6667V8.51585C4.83333 8.42744 4.86845 8.34266 4.93096 8.28015V8.28015C5.14095 8.07016 5.5 8.21888 5.5 8.51585V10.6667C5.5 10.8508 5.35076 11 5.16667 11V11ZM7 11C6.81591 11 6.66667 10.8508 6.66667 10.6667V8.52535C6.66667 8.22705 7.02846 8.07894 7.23764 8.2916V8.2916C7.29897 8.35395 7.33333 8.4379 7.33333 8.52535V10.6667C7.33333 10.8508 7.1841 11 7 11V11ZM8.83333 11C8.64924 11 8.5 10.8508 8.5 10.6667V8.52696C8.5 8.43855 8.53512 8.35377 8.59763 8.29126V8.29126C8.80762 8.08127 9.16667 8.22999 9.16667 8.52696V10.6667C9.16667 10.8508 9.01743 11 8.83333 11V11ZM10.6667 11C10.4826 11 10.3333 10.8508 10.3333 10.6667V6.73807C10.3333 6.64967 10.3685 6.56488 10.431 6.50237V6.50237C10.641 6.29238 11 6.4411 11 6.73807V10.6667C11 10.8508 10.8508 11 10.6667 11V11ZM3.17046 8.20854C3.10736 8.27119 3 8.22649 3 8.13758V7.5166C3 7.4633 3.02127 7.41222 3.05909 7.37467L5.96969 4.48485C6.04788 4.40723 6.17412 4.40745 6.25203 4.48536L7.74722 5.98055C7.82542 6.05875 7.95225 6.05864 8.03031 5.9803L10.8292 3.17145C10.8921 3.10828 11 3.15285 11 3.24203V3.86181C11 3.91473 10.979 3.96549 10.9417 4.00298L8.03031 6.92474C7.95225 7.00308 7.82542 7.0032 7.74722 6.92499L6.25203 5.4298C6.17412 5.3519 6.04788 5.35167 5.96969 5.4293L3.17046 8.20854Z",
    fill: "#5D6F88"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 13,
    height: 13,
    rx: 0.5,
    stroke: "#5D6F88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesReport);
export default __webpack_public_path__ + "static/media/sales_report.62048d4050b9fd8d860001fa604cd761.svg";
export { ForwardRef as ReactComponent };